export const getDrugsTranslatedLabel = (t, drugs) => {
  if (Array.isArray(drugs)) {
    if (drugs.length === 1) {
      return t(`questionnaire.questions.drugs_received.${drugs[0]}`);
    }
    return drugs.map((drug) => t(`questionnaire.questions.drugs_received.${drug}`)).join(' + ');
  }
  return drugs ? drugs.split('+').map((drug) => t(`questionnaire.questions.drugs_received.${drug}`)).join(' + ') : '';
};
